import VirtuozzoColorScheme from '@uikit/ui-syntax/dist/js/colors/virtuozzo';

/**
 * Virtuozzo brand colors (VSTOR-147162).
 *
 * The scheme is the `@uikit/ui-syntax` "virtuozzo" preset with the brand book
 * colors applied on top. It has to be passed through `prepareThemeColors`
 * (`@uikit/ui-kit/colors/js/utils/theme`) before use: that derives hover, active,
 * translucent and scrollbar variables from the base colors and converts every
 * value to hex, so browsers without oklch support get valid colors too.
 *
 * `prepareThemeColors` reads the base colors with `oklchCssToHex`, so the values
 * below must stay in oklch format.
 */
const PRIMARY = 'oklch(42.892% 0.11972 260.10)'; // #254D90: app menu, buttons, links, active elements
const ACCENT = 'oklch(55.874% 0.18813 23.22)'; // #CB333B: selected app menu item, secondary accent
const TEXT = 'oklch(28.003% 0.02560 287.90)'; // #282735: main text
const SURFACE = 'oklch(95.890% 0.01795 272.31)'; // #EDF1FE: selected and hover backgrounds, toggle

const alpha = (color: string, value: number): string => color.replace(/\)$/, ` / ${value})`);

const vzBrandColors = {
  '--av-nav-primary': PRIMARY,
  '--av-nav-secondary': ACCENT,

  '--av-brand-primary': PRIMARY,
  '--av-brand-accent': alpha(PRIMARY, 0.1),
  '--av-brand-light': alpha(PRIMARY, 0.3),
  '--av-brand-lightest': alpha(PRIMARY, 0.05),
  '--av-fixed-button': PRIMARY,
  '--av-fixed-button-light': alpha(PRIMARY, 0.3),
  '--av-fixed-link': PRIMARY,

  '--av-brand-secondary': ACCENT,
  '--av-brand-secondary-light': alpha(ACCENT, 0.3),
  '--av-brand-secondary-accent': alpha(ACCENT, 0.15),

  '--av-fixed-primary': TEXT,
  '--av-fixed-secondary': alpha(TEXT, 0.9),
  '--av-fixed-light': alpha(TEXT, 0.7),
  '--av-fixed-lighter': alpha(TEXT, 0.4),
  '--av-fixed-lightest': alpha(TEXT, 0.2),
  '--av-fixed-invisible': alpha(TEXT, 0.1),
  '--av-dark': alpha(TEXT, 0.9),
  '--av-scroll-thumb': alpha(TEXT, 0.4),

  '--av-solid-brand-accent': SURFACE,
  // PRIMARY at 20% over white, the solid pair of `--el-secondary-active`
  '--el-solid-secondary-active': '#d3dbe9',
};

const vzOverrides = {
  '--av-brand-primary-hover': 'var(--el-primary-hover)',
  '--av-brand-secondary-active': 'var(--el-secondary-active)',
  '--av-brand-secondary-hover': 'var(--el-secondary-hover)',
  '--av-fixed-focus': 'var(--el-secondary-active)',
  '--av-secondary-hover': 'var(--el-secondary-hover)',
};

export default {
  ...VirtuozzoColorScheme,
  ...vzBrandColors,
  ...vzOverrides,
};
